import useUserAccount from "../hooks/useUserAccount";
import React, { useEffect, useState } from "react";
import useFormatter from "../hooks/useFormatter";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";
import {Badge, Button, Spinner} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import DeleteConnectedEmailModal from "./DeleteConnectedEmailModal";

const messages = defineMessages({
    title: {
        id: "Liitetyt sähköpostit",
        defaultMessage: "Liitetyt sähköpostit"
    },
    description: {
        id: "Tässä näkyviä sähköposteja voidaan käyttää kirjautumiseen. Lisätäksesi toisen sähköpostin, kirjaudu sisään ja vahvista henkilötunnuksesi uudella osoitteella.",
        defaultMessage: "Tässä näkyviä sähköposteja voidaan käyttää kirjautumiseen. Lisätäksesi toisen sähköpostin, kirjaudu sisään ja vahvista henkilötunnuksesi uudella osoitteella."
    },
    current: {
        id: "Nykyinen tili",
        defaultMessage: "Nykyinen tili"
    },
    remove: {
        id: "Poista",
        defaultMessage: "Poista"
    },
    lastLogin: {
        id: "Viimeisin kirjautuminen",
        defaultMessage: "Viimeisin kirjautuminen"
    }
})

const AccountConnectedEmails = (props) => {
    const { userGetAccounts, userAccounts } = useUserAccount();
    const { formatDate, formatTime } = useFormatter();
    const [loading, setLoading] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(null);

    const lng = props.intl.formatMessage;

    useEffect(() => {
        const loadAccounts = async () => {
            setLoading(true);
            try {
                await userGetAccounts();
            } finally {
                setLoading(false);
            }
        }
        void loadAccounts();
    }, []);

    /**
     * Handle remove connected email
     * @param {object} account
     * @returns {Promise<void>}
     */
    const handleRemove = async (account) => {
        setSelectedAccount(account);
    }

    const accountRow = (account, border) => (
        <div key={account.username} className={`d-flex justify-content-between mt-1 mb-1 border-light ${border ? 'border-bottom' : ''} border-1 pb-1 pt-1`}>
            <div className='col-sm-8'>
                <div>{account.email}</div>
                <small className='text-light'>
                    {lng(messages.lastLogin)}:&nbsp;
                    {formatDate(account.lastLoginAt)} {formatTime(account.lastLoginAt)}
                </small>
            </div>
            <div className='col-sm-4 justify-content-end d-flex align-items-center'>
                {props.currentAccountEmail === account.email && (
                    <Badge className='d-flex align-items-center'>{lng(messages.current)}</Badge>
                )}
                {props.currentAccountEmail !== account.email && (
                    <Button
                        variant='outline-secondary'
                        className='btn-circle'
                        title={lng(messages.remove)}
                        onClick={() => handleRemove(account)}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} aria-hidden="true" />
                    </Button>
                )}
            </div>
        </div>
    )

    return (
        <div className='mt-5'>
            <h4>
                {lng(messages.title)}
            </h4>
            <p>
                {lng(messages.description)}
            </p>
            <div>
                {loading && <Spinner animation="border" size="lg" />}
                {Array.isArray(userAccounts) && userAccounts.map((account, index) => accountRow(account, index < userAccounts.length - 1))}
            </div>
            <DeleteConnectedEmailModal
                account={selectedAccount}
                show={selectedAccount !== null}
                onHide={() => setSelectedAccount(null)}
            />
        </div>
    )
}

AccountConnectedEmails.propTypes = {
    intl: PropTypes.object.isRequired,
    currentAccountEmail: PropTypes.string
};

export default injectIntl(AccountConnectedEmails);
